import React, { Component } from 'react';
import { intlShape, FormattedHTMLMessage, injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';
import CheckBox from '../../../shared-components/CheckBox/CheckBox';
import { DE_PRIVACY_POLICY_URL, DE_CREDIT_CHECK_URL } from '../../config/DEConstants';
const LOCALE_PREFIX = 'DE/pages/PersonalInfoPage/CheckCredit';


export class AgreeToCheckCreditCheckBox extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        allowErrorPopout: PropTypes.bool.isRequired,
        locale: PropTypes.string
    };

    static defaultProps = {
        allowErrorPopout: false
    };

    render() {
        const { intl, allowErrorPopout, locale } = this.props;
        const localeQueryStringParam = locale ? 'locale.x=' + locale : '';
        const checkCreditAgreeLabel = (
            <div>
                <FormattedHTMLMessage
                    id={`${LOCALE_PREFIX}.agreeToCheckCreditContent`}
                    values={{
                        dePrivacyPolicyUrl: DE_PRIVACY_POLICY_URL,
                        deCreditCheckUrl: DE_CREDIT_CHECK_URL,
                        locale: localeQueryStringParam
                    }}
                />
            </div>
        );
        return (
            <Field
                id="agreeToCheckCredit"
                name="agreeToCheckCredit"
                label={checkCreditAgreeLabel}
                component={CheckBox}
                validate={isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.agreeToCheckCredit.agreeCreditCheckError`}))}
            />
        );
    }
}
export default injectIntl(AgreeToCheckCreditCheckBox);

